import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  Box,
  TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { updateEndorsementFormData } from 'src/features/rfqDataSlice';

const RiskDescription = ({ policyDetails }) => {
  const dispatch = useDispatch();

  const [isEditable, setIsEditable] = useState(false);

  const [riskData, setRiskData] = useState({
    riskDescription: false,
    riskDescriptionValue: policyDetails?.riskDescription,
  });

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;

    const valueFromPolicy =
      policyDetails?.riskDescription || '';

    setIsEditable(checked);

    setRiskData({
      riskDescription: checked,
      riskDescriptionValue:valueFromPolicy,
    });
  };

  useEffect(() => {
    dispatch(
      updateEndorsementFormData({
        riskDescription:{
            isSelected:riskData?.riskDescription,
            oldValue:riskData?.riskDescription?policyDetails?.riskDescription:'',
            newValue:''
        }  
      })
    );
  }, [riskData, dispatch]);

  return (
    <>
      {policyDetails?.riskDescription && (
        <>
          <Box sx={{ mb: 1, display: 'flex', gap: 1 }}>
            <Typography
              variant="h5"
              className="heading"
              sx={{
                background: 'rgb(9 84 174)',
                color: '#fff',
                py: 1,
                fontWeight: 'bold',
                width: '100%',
                pl: 2,
              }}
            >
              Risk Description
            </Typography>
          </Box>

          <Grid container spacing={2} sx={{ pl: 2 }}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={riskData.riskDescription}
                    onChange={handleCheckboxChange}
                  />
                }
                label={policyDetails?.riskDescription}
              />
            </Grid>

            
          </Grid>
        </>
      )}
    </>
  );
};

export default RiskDescription;
